import {
  useResizeObserver as _useResizeObserver,
  type MaybeComputedElementRef,
  type MaybeElement,
  type MaybeRefOrGetter,
  type UseResizeObserverOptions
} from '@vueuse/core'

type ResizeObserverCallback = (
  entries: ReadonlyArray<ResizeObserverEntry>,
  observer: ResizeObserver
) => void

export function useResizeObserver(
  target: MaybeComputedElementRef | MaybeComputedElementRef[] | MaybeRefOrGetter<MaybeElement[]>,
  callback: ResizeObserverCallback,
  options?: UseResizeObserverOptions
) {
  return _useResizeObserver(target, callback, options)
}
